import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isCollapse: false,
    iconList: [
      'el-icon-info',
      'el-icon-error',
      'el-icon-success',
      'el-icon-warning',
      'el-icon-question',
      'el-icon-back',
      'el-icon-arrow-left',
      'el-icon-arrow-down',
      'el-icon-arrow-right',
      'el-icon-arrow-up',
      'el-icon-caret-left',
      'el-icon-caret-bottom',
      'el-icon-caret-top',
      'el-icon-caret-right',
      'el-icon-d-arrow-left',
      'el-icon-d-arrow-right',
      'el-icon-minus',
      'el-icon-plus',
      'el-icon-remove',
      'el-icon-circle-plus',
      'el-icon-remove-outline',
      'el-icon-circle-plus-outline',
      'el-icon-close',
      'el-icon-check',
      'el-icon-circle-close',
      'el-icon-circle-check',
      'el-icon-zoom-out',
      'el-icon-zoom-in',
      'el-icon-d-caret',
      'el-icon-sort',
      'el-icon-sort-down',
      'el-icon-sort-up',
      'el-icon-tickets',
      'el-icon-document',
      'el-icon-goods',
      'el-icon-sold-out',
      'el-icon-news',
      'el-icon-message',
      'el-icon-date',
      'el-icon-printer',
      'el-icon-time',
      'el-icon-bell',
      'el-icon-mobile-phone',
      'el-icon-service',
      'el-icon-view',
      'el-icon-menu',
      'el-icon-more',
      'el-icon-more-outline',
      'el-icon-star-on',
      'el-icon-star-off',
      'el-icon-location',
      'el-icon-location-outline',
      'el-icon-phone',
      'el-icon-phone-outline',
      'el-icon-picture',
      'el-icon-picture-outline',
      'el-icon-delete',
      'el-icon-search',
      'el-icon-edit',
      'el-icon-edit-outline',
      'el-icon-rank',
      'el-icon-refresh',
      'el-icon-share',
      'el-icon-setting',
      'el-icon-upload',
      'el-icon-upload2',
      'el-icon-download',
      'el-icon-loading',
      'zion-fill',
      'zion-education',
      'zion-back',
      'zion-asset-stats',
      'zion-notice',
      'zion-recording',
      'zion-firefox',
      'zion-amplification',
      'zion-fire',
      'zion-filter',
      'zion-big',
      'zion-classification',
      'zion-setting',
      'zion-supply',
      'zion-people',
      'zion-task',
      'zion-add',
      'zion-manage',
      'zion-table',
      'zion-message-template',
      'zion-search',
      'zion-out',
      'zion-broadcast',
      'zion-complete',
      'zion-by',
      'zion-save',
      'zion-delete',
      'zion-chrome',
      'zion-buy',
      'zion-fill-more',
      'zion-bug',
      'zion-shift',
      'zion-assign',
      'zion-telephone',
      'zion-upload',
      'zion-log',
      'zion-switch',
      'zion-file-bold',
      'zion-password',
      'zion-download',
      'zion-share',
      'zion-verification',
      'zion-invalid',
      'zion-user',
      'zion-password-bold',
      'zion-gift',
      'zion-calendar',
      'zion-program',
      'zion-data',
      'zion-mobile',
      'zion-time',
      'zion-head',
      'zion-up',
      'zion-box',
      'zion-replace',
      'zion-code',
      'zion-scanning',
      'zion-task-list',
      'zion-book',
      'zion-image',
      'zion-send',
      'zion-align',
      'zion-my-order',
      'zion-contract-draft',
      'zion-administrator',
      'zion-contract',
      'zion-file',
      'zion-solution',
      'zion-home',
      'zion-category',
      'zion-template',
      'zion-pay',
      'zion-output',
      'zion-more',
      'zion-project',
      'zion-license',
      'zion-company',
      'zion-problem',
      'zion-order',
      'zion-error',
      'zion-failure',
      'zion-edit',
      'zion-information',
      'zion-list',
      'zion-record',
      'zion-configure',
      'zion-down',
      'zion-visit',
      'zion-write',
      'zion-copy',
      'zion-close',
      'zion-stat-bold',
      'zion-create',
      'zion-menu',
      'zion-input',
      'zion-url',
      'zion-expand',
      'zion-backup',
      'zion-management',
      'zion-plus',
      'zion-choice',
      'zion-import',
      'zion-export',
      'zion-cost',
      'zion-small'
    ]
  },
  mutations: {
    changeCollapseStatus(state){
      state.isCollapse = !state.isCollapse
    }
  },
  actions: {
  },
  modules: {
  }
})
